import template from './modal.template.html';
import DebouncedToggle from '../debounced-toggle';

export class ModalController extends DebouncedToggle {
	constructor($timeout) {
		'ngInject';

		super($timeout);
	}

	$onInit() {}

	closeModal() {
		this._debounceToggle()
			.then(() => {
				this.onClose();
			})
			.catch(this._ignore);
	}
}

export const ModalComponent = {
	template,
	bindings: {
		showModal: '<',
		onClose: '&?'
	},
	transclude: true,
	controller: 'ModalController as vm'
};
